// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__1s89M","imgLogo":"Home_imgLogo__1s0uh"};